import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPLOYERPROFILEWIDGET_MOCK, MANAGEEMPLOYERSWIDGET_MOCK, MYDOCUMENTSWIDGET_MOCK, REPORTSWIDGET_MOCK, SETUPWIDGET_MOCK, WIDGETINFO_MOCK } from '@core/mocks';
import { RoleAdminWidget, WidgetInfo, LeaveAdminWidget, MyDocumentsWidget, SubmitNewRequestWidget, MyCaseWidgets, SubmitIntermittentTimeWidgets, ManageEmployersWidget, EmployerProfileWidget, ReportsWidget, SetupWidgetInfo } from '@core/models';
import { ManageEmployeesWidget } from '@core/models/widgets/manage-employees-widget.model';
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs';
import { catchError, delay, map, tap } from 'rxjs/operators';
import { ConstantsService } from './constants.service';
import { EmailTemplatesWidget } from '@core/models/widgets/email-templates-widget.model';
import { EMAILTEMPLATES_WIDGET } from '@core/mocks/widgets/email-templates-widget.mock';
import { SetupWidget } from '@core/models/widgets/setup-widget.model';
import { ActionItemsTemplatesWidget } from '@core/models/widgets/action-item-templates-widget.model';
import { ACTIONITEM_TEMPLATES_WIDGET } from '@core/mocks/widgets/action-item-template-widget.mock';
import { ReviewRequestsWidget } from '@core/models/widgets/review-requests-widget.model';
import { REVIEW_REQUESTS_WIDGET } from '@core/mocks/widgets/review-requests-widget.mock';
import { SubmitHoursRequestWidgets } from '@core/models/widgets/submit-hours-request-widget.model';
import { SUBMIT_HOURS_REQ_WIDGET } from '@core/mocks/widgets/submit-hours-requests-widget.mock';
import { WorkSchedulesWidget } from '@core/models/widgets/work-schedules-widget.model';
import { WORK_SCHED_WIDGET } from '@core/mocks/widgets/work-schedules-widget.mock';
import { LeaveReasonsWidget } from '@core/models/widgets/leave-reasons-widget.model';

@Injectable({
  providedIn: 'root',
})
export class WidgetService {
  private widgetInfoSubject: BehaviorSubject<WidgetInfo>;
  widgetInfo$: Observable<WidgetInfo>;

  get widgetInfo(): WidgetInfo {
    return this.widgetInfoSubject.value;
  }

  set widgetInfo(info: WidgetInfo) {
    this.widgetInfoSubject.next(info);
  }

  constructor(private constants: ConstantsService, private http: HttpClient) {
    this.widgetInfoSubject = new BehaviorSubject(null);
    this.widgetInfo$ = this.widgetInfoSubject.asObservable();
  }

  // #region Home Dashboard Widgets (11)

  public getRoleAdminWidget(): Observable<RoleAdminWidget> {
    return this.http.get<RoleAdminWidget>(`${this.constants.WIDGETS_API}/getRoleAdminWidget`);
    //return of(ROLEADMINWIDGET_MOCK);
  }

  public getMyDocumentsWidget(): Observable<MyDocumentsWidget> {
    return this.http.get<MyDocumentsWidget>(`${this.constants.WIDGETS_API}/getMyDocumentsWidget`);
    //return of(MYDOCUMENTSWIDGET_MOCK);
  }

  public getLeaveAdminWidget(): Observable<LeaveAdminWidget> {
    return this.http.get<LeaveAdminWidget>(`${this.constants.WIDGETS_API}/getLeaveAdminWidget`);
    //return of(LEAVEADMINWIDGET_MOCK);
  }

  public getSubmitNewRequestWidget(): Observable<SubmitNewRequestWidget> {
    return this.http.get<SubmitNewRequestWidget>(`${this.constants.WIDGETS_API}/getSubmitNewRequestWidget`);
    //return of(SUBMITNEWREQUESTWIDGET_MOCK);
  }
  
  public getMyCaseWidgets(): Observable<MyCaseWidgets> {
    return this.http.get<MyCaseWidgets>(`${this.constants.WIDGETS_API}/getMyCaseWidgets`);
    //return of(MYCASEWIDGETS_MOCK);
  }

  public getSubmitIntermittentTimeWidgets(): Observable<SubmitIntermittentTimeWidgets> {
    return this.http.get<SubmitIntermittentTimeWidgets>(`${this.constants.WIDGETS_API}/getSubmitIntermittentTimeWidgets`);
    //return of (SUBMITINTERMITTENTTIMEWIDGETS_MOCK);
  }

  public getSubmitHoursRequestWidgets(): Observable<SubmitHoursRequestWidgets> {
    return this.http.get<SubmitHoursRequestWidgets>(`${this.constants.WIDGETS_API}/getSubmitHoursRequestWidgets`);
    // return of (SUBMIT_HOURS_REQ_WIDGET);
  }

  public getManageEmployersWidget(): Observable<ManageEmployersWidget> {
    return this.http.get<ManageEmployersWidget>(`${this.constants.WIDGETS_API}/getManageEmployersWidget`);
    //return of (MANAGEEMPLOYERSWIDGET_MOCK);
  }

  public getManageEmployeesWidget(): Observable<ManageEmployeesWidget> {
    return this.http.get<ManageEmployersWidget>(`${this.constants.WIDGETS_API}/getManageEmployeesWidget`);
  }

  getEmployerProfileWidget(): Observable<EmployerProfileWidget> {
    return this.http.get<EmployerProfileWidget>(`${this.constants.WIDGETS_API}/getEmployerProfileWidget`);
    //return of (EMPLOYERPROFILEWIDGET_MOCK);
  }

  public getReviewRequestsWidget(): Observable<ReviewRequestsWidget> {
    return this.http.get<ReviewRequestsWidget>(`${this.constants.WIDGETS_API}/getReviewRequestsWidget`);
    // return of (REVIEW_REQUESTS_WIDGET);
  }

  public getReportsWidget(): Observable<ReportsWidget> {
    return this.http.get<ReportsWidget>(`${this.constants.WIDGETS_API}/getReportsWidget`);
    //return of (REPORTSWIDGET_MOCK);
  }

  public getSetupWidget(): Observable<SetupWidget> {
    return this.http.get<SetupWidget>(`${this.constants.WIDGETS_API}/getSetupWidget`);
    // return of (SETUPWIDGET_MOCK).pipe(delay(1000));
  }

  // #endregion Home Dashboard Widgets (11)

  // #region Setup Dashboard Widgets (4)

  public getEmailTemplatesWidget(): Observable<EmailTemplatesWidget> {
    return this.http.get<EmailTemplatesWidget>(`${this.constants.WIDGETS_API}/getEmailTemplatesWidget`);
    //return of (EMAILTEMPLATES_WIDGET).pipe(delay(1000));
  } 

  public getWorkSchedulesWidget(): Observable<WorkSchedulesWidget> {
    return this.http.get<WorkSchedulesWidget>(`${this.constants.WIDGETS_API}/getWorkSchedulesWidget`);
    // return of (WORK_SCHED_WIDGET).pipe(delay(1000));
  } 

  public getActionItemsTemplatesWidget(): Observable<ActionItemsTemplatesWidget> {
    return this.http.get<ActionItemsTemplatesWidget>(`${this.constants.WIDGETS_API}/getActionItemsTemplatesWidget`);
    //return of (ACTIONITEM_TEMPLATES_WIDGET).pipe(delay(1000));
  }

  public getLeaveReasonsWidget(): Observable<LeaveReasonsWidget> {
    return this.http.get<LeaveReasonsWidget>(`${this.constants.WIDGETS_API}/getLeaveReasonsWidget`);
    //return of (ACTIONITEM_TEMPLATES_WIDGET).pipe(delay(1000));
  }

  // #endregion Setup Dashboard Widgets (4)

  public getWidgetInfo(): Observable<WidgetInfo> {
    return this.http.get<WidgetInfo>(`${this.constants.WIDGETS_API}/getWidgetInfo`);
    //return of(WIDGETINFO_MOCK).pipe(tap((res) => (this.widgetInfo = res)));
  }

  public getSetupWidgetInfo(): Observable<SetupWidgetInfo> {
    const setupObservables$ = combineLatest([
      this.getEmailTemplatesWidget().pipe(catchError(()=>{return of(null)})),
      this.getWorkSchedulesWidget().pipe(catchError(()=>{return of(null)})),
      this.getActionItemsTemplatesWidget().pipe(catchError(()=>{return of(null)})),
      this.getLeaveReasonsWidget().pipe(catchError(()=>{return of(null)})),
    ]);

    return combineLatest([setupObservables$]).pipe(
      map(([[et, ws, ait, lr]]) => {
        return { et, ws, ait, lr };
      })
    );
  }
}
